<template>
  <Base :base-id="'lb-my-coupon'" :base-class="'coupon-popup'">
    <template #header>
      <h3 class="modal-title pt-2">
        <span class="d-inline-block align-middle h2 font-weight-bold">我的折價券</span>
      </h3>
      <a href="#" class="r-lightbox__close" @click="closeModal" />
    </template>
    <template #body>
      <div class="controls-item custom-ui lh-1 mb-4">
        <input
          id="coupon-default"
          v-model="selfFillin"
          :value="selfFillin"
          :checked="selfFillin !== ''"
          class="radio"
          name="coupon-selected"
          type="radio"
          @click="enterCoupon"
        />
        <label for="coupon-default">
          <span class="controls-float">
            <input
              v-model.trim="selfFillin"
              style="margin-top: -10px"
              type="text"
              class="text--m ml-1 text d-inline-block"
              name="self-coupon"
              placeholder="自行輸入折價券代碼"
            />
          </span>
        </label>
      </div>
      <div v-for="(c, index) in modalData" :key="index" class="controls-item custom-ui lh-1 mb-4">
        <input
          :id="'coupon-' + index"
          v-model="couponSelected"
          class="radio"
          name="coupon-selected"
          type="radio"
          :value="c.Code"
        />
        <label :for="'coupon-' + index">
          <div class="ml-1">
            <span>{{ c.Code }}</span>
            <span>{{ c.Description }}</span>
            <p class="pt-1">使用期限: {{ c.EndDate }}</p>
          </div>
        </label>
      </div>
      <div class="text-primary lh-15 py-3">
        <div class="pb-2">單筆訂單限抵一張折價券。</div>
        <div>
          取消訂單、辦理整筆退貨或退貨後之保留商品未符合折價券使用條件時，若折價券能仍在使用期限內，將歸還至帳戶中。
        </div>
      </div>
    </template>
    <template #footer>
      <div class="pb-2 w-50 mx-auto">
        <a
          id="btn-coupon-discount"
          class="btn btn-primary btn-outline-secondary btn-sm w-100"
          href="#"
          @click.prevent="checkCoupon"
        >
          使用折扣碼
        </a>
      </div>
    </template>
  </Base>
</template>

<script setup>
import { ref, watch } from 'vue';
import { storeToRefs } from 'pinia';
import Base from '@global/components/common/modal/Base.vue';

import useAlert from '@global/composable/useAlert';
import useModalStore from '@global/stores/useModalStore';

const { alertDialog } = useAlert();

const modalStore = useModalStore();
const { closeModal } = modalStore;
const { modalData } = storeToRefs(modalStore);

const couponSelected = ref('');
const selfFillin = ref('');

watch(selfFillin, (nV) => {
  if (nV !== '') {
    couponSelected.value = '';
  }
});

watch(couponSelected, (nV) => {
  if (nV !== '') {
    selfFillin.value = '';
  }
});

function enterCoupon() {
  couponSelected.value = '';
}

function checkCoupon() {
  if (couponSelected.value === '' && selfFillin.value === '') {
    alertDialog.alert('請輸入或選擇折價代碼');
    return;
  }

  modalData.value = { coupon: selfFillin.value === '' ? couponSelected.value : selfFillin.value };
}
</script>
